// @module C3.PDPSerialLotFunctionality.Initial
define('C3.PDPSerialLotFunctionality.Initial.View'
,	[
	'tekyard_pdpseriallotfunctionality_initial.tpl'
	
	,	'C3.PDPSerialLotFunctionality.Skeleton.View'
	,   'C3.PDPSerialLotFunctionality.SerialLotData.View'
	,   'C3.PDPSerialLotFunctionality.SerialLotData.Model'
	
	,	'Backbone.View'
    ]
, function (
	tekyard_pdpseriallotfunctionality_initial_tpl
	
	,	PDPSkeletonView
	,   SerialLotDataView
	,   SerialLotModel
	
	,	BackboneView
)
{
    'use strict';

	// @class C3.PDPSerialLotFunctionality.Initial.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pdpseriallotfunctionality_initial_tpl

	,	initialize: function (options) {
			  this.application = options.application;
			  this.layout = options.layout;
			  this.iteminfo = options.iteminfo;
			  this.container = options.container;

			  this.model = new SerialLotModel();
		      this.loading = true;
		      this.skeletonView = null;
		      //console.log(this.iteminfo)

		      this.item = this.iteminfo.item;
		      this.itemid = this.item.internalid;

		}

	,	events: {
		}

	,	bindings: {
		}

	,   render: function () {
	      if (this.loading) {
	        BackboneView.prototype.render.apply(this, arguments);

	        var self = this;
	        this.model.fetch({
	          data: {
	            itemid: self.itemid,
	            islotitem: (self.item.islotitem === true || self.item.islotitem === 'T') ? 'T' : 'F'
	          }
	        }).then(function (res) {
	          //console.log(res)	
	          self.loading = false;
	          self.render(); // swap skeleton → data view
	        });
	      } else {
	        BackboneView.prototype.render.apply(this, arguments);
	      }
	    }	

	, 	childViews: {
		  'SerialLot.Data': function () {

	    	if (this.loading) {
	          if (!this.skeletonView) {
	            this.skeletonView = new PDPSkeletonView();
	          }
	          return this.skeletonView;
	        } else {
	          if (!this.dataView) {
	            // only create once
	            this.dataView = new SerialLotDataView({ layout:this.layout,model: this.model,application: this.application,item:this.item });

	            if (this.skeletonView) {
	              this.skeletonView.fadeOut();
	              this.skeletonView = null;
	            }
	          }
	          return this.dataView;
	        }
		  }
		}


		//@method getContext @return Tekyard.PDPSerialLotFunctionality.Initial.View.Context
	,	getContext: function getContext()
		{
			return {
				
			};
		}
	});
});
